<template>
  <div class="mmar">
    <!--搜索框-->
    <div>
      <el-input v-model="params.JTMC" placeholder="请输入集团名称" style="width:15%;margin-left:20px"></el-input>
      <el-date-picker
        v-model="params.timeRange"
        :picker-options="pickerOptions"
        align="right"
        end-placeholder="结束日期"
        range-separator="—"
        start-placeholder="开始日期"
        type="daterange"
        unlink-panels
        value-format="yyyy-MM-dd"
        style="margin-left:10px">
      </el-date-picker>

      <el-button class="btnB" icon="el-icon-search" style="margin-left: 10px" @click="search()">搜索
      </el-button>
      <el-button icon="el-icon-refresh" class="btnR" @click="reset()">重置
      </el-button>
      <el-button class="btnB" icon="el-icon-plus" @click="addEduGroup()">新增
      </el-button>

    </div>
    <!--表格数据-->
    <div style="margin-top: 30px;">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;">
        <el-table-column label="集团名称" prop="JTMC" width="350">
        </el-table-column>
        <el-table-column label="LOGO" prop="LOGO" width="200">
          <template slot-scope="scope">
            <!-- <el-image style="width: 100px; height: 50px" :src="url +scope.row.name"></el-image> -->
            <!--            <el-image :src=scope.row.LOGO style=" height: 45px"></el-image>-->
            {{scope.row.LOGO==null || scope.row.LOGO==''?'-':''}}
            <div v-if="scope.row.LOGO!=null && scope.row.LOGO!=''" @click="show(scope.row.LOGO)">
<!--            <div @click="show(scope.row.LOGO)" >-->
              <el-image style="height: 150px" :preview-src-list="srcList" :src="tpurl+scope.row.LOGO" fit="fill">fit="fill"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="XZSTAMP" width="300">
        </el-table-column>
        <el-table-column label="操作" width="">
          <template slot-scope="scope">
            <div class="link_out">
              <el-link type="primary" :underline="false" @click="update(scope.row)"> 修改</el-link>
              <el-link type="primary" :underline="false" @click="deleteLogical(scope.row)"> 删除</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    分页-->
    <div class="block pageBlock">
      <el-pagination :current-page="params.curpage" :page-size="params.pagesize"
                     :page-sizes="[10, 20, 30, 40]" :total="total" background layout="total, sizes, prev, pager, next, jumper"
                     @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <div style="clear:both"></div>
    <!--    新增，弹窗-->
    <el-dialog :before-close="closeWindow" :modal-append-to-body="false" :title="title" :visible.sync="dialogVisible" width="50%">
      <el-form ref="form" :label-position="right" :model="form" label-width="90px" :rules="rules">
        <el-form-item label="集团名称:" prop="JTMC">
          <el-input v-model="form.JTMC" placeholder="集团名称" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item v-if="type == 2" label="新增时间">
          <span>{{ form.XZSTAMP }}</span>
        </el-form-item>
        <el-form-item v-if="type == 2" label="修改时间">
          <span>{{ form.XGSTAMP }}</span>
        </el-form-item>
        <el-form-item label="LOGO:">
          <div v-if="form.LOGO !== ''">
            <img :src="tpurl + form.LOGO" style="width: 5vw;" @click="openImg(tpurl + form.LOGO)"/>
          </div>
          <el-upload :action="url"
                     :before-upload="beforeUpload"
                     :file-list="fileList"
                     :http-request="afterRead"
                     :limit="1"
                     :on-exceed="exceed"
                     :on-preview="handlePreview"
                     :on-remove="handleRemove"
                     class="upload-demo"
                     list-type="picture">
            <el-button size="medium" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5M</div>
          </el-upload>
        </el-form-item>
        <!--简介-->
        <el-form-item label="简介:">
          <div>
            <editor id="editor_jj" :afterChange="afterChange()" :content.sync="form.JTJJDZD"
                    :loadStyleMode="false"
                    height="500px" width="1000px"
                    @on-content-change="onContentChange"></editor>
          </div>
        </el-form-item>
        <!--章程-->
        <el-form-item label="章程:">
          <div>
            <editor id="editor_zc" :afterChange="afterChange()" :content.sync="form.JTZCDZD"
                    :loadStyleMode="false"
                    height="500px" width="1000px"
                    @on-content-change="onContentChange"></editor>
          </div>
        </el-form-item>

        <!--议事规则-->
        <el-form-item label="议事规则:">
          <div>
            <editor id="editor_ysgz" :afterChange="afterChange()" :content.sync="form.YSGZDZD"
                    :loadStyleMode="false"
                    height="500px" width="1000px"
                    @on-content-change="onContentChange"></editor>
          </div>
        </el-form-item>
        <!--秘书处信息-->
        <el-form-item label="秘书处信息:">
          <div>
            <editor id="editor_jtmsc" :afterChange="afterChange()" :content.sync="form.JTMSCDZD"
                    :loadStyleMode="false"
                    height="500px" width="1000px"
                    @on-content-change="onContentChange"></editor>
          </div>
        </el-form-item>

        <!--入会须知-->
        <el-form-item label="入会须知:">
          <div>
            <editor id="editor_rhxz" :afterChange="afterChange()" :content.sync="form.RHXZDZD"
                    :loadStyleMode="false"
                    height="500px" width="1000px"
                    @on-content-change="onContentChange"></editor>
          </div>
        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button @click="closeWindow">关 闭</el-button>

          <el-button v-if="type == 1" type="primary" @click="onSubmit">新 增</el-button>
          <el-button v-if="type == 2" type="primary" @click="onUpdate">修 改</el-button>
<!--          <el-button @click="closeWindow">关 闭</el-button>-->
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  addEduGroup,
  addEduGroupNews,
  getEduGroup,
  getListEduGroup,
  getListEduGroupNews, updateEduGroup,
  updateEduGroupNews, updateEGMToExamine
} from "../../api/eduGroupApi/eduGroupAx";
import editor from '@/components/Kindeditor/index.vue'
import config from "../../../config/config.js";
import {getBannerXq, updateBanner} from "../../api/xxptszApi/lbtszAx";
import axios from "axios";

export default {
  data() {
    return {
      rules:{
        JTMC:[{required: true, message: '请输入职教联盟名称', trigger: 'blur' }],
      },
      tpurl: config.fileShowUrl,   //图片地址前缀
      url: config.fileUrl1,//图片上传地址

      fileList: [],//图片集合
      src: '',
      srcList: [],
      loading: false,
      dialogVisible: false,
      title: '',
      type: '',
      tableData: [],
      params: {
        JTMC: '',
        curpage: 1,
        pagesize: 10,
        timeRange: '',
      },
      form: {},
      right:'right',
      total: 0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },//时间选择器
    }
  },
  methods: {
    //图片选择器
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    //上传前  检查文件格式
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    //文件超出个数的钩子
    exceed() {
      this.$message('只能上传一张标题图片');
    },
    //自定义上传方法
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let params = new FormData();
      params.append("file", file.file);
      //var token = Cookies.get("token")
      let cg = {
        headers: {
          //添加请求头
          "Content-Type": "multipart/form-data"
        },
        // headers: {
        //   //添加请求头
        //   "Content-Type": "multipart/form-data",
        //   'token': token
        // },
      };

      axios
        .post(this.url, params, cg)
        .then((res) => {
          //console.log(res)
          this.form.LOGO = res.data.data.fileName;
        });
    },
    show(src) {
      this.srcList = []
      this.srcList.push(this.tpurl + src)
    },//页面图片
    //获取列表
    getListEduGroup() {
      getListEduGroup(this.params).then(res => {
        //console.log(res)
        if (res.status == "success") {
          this.tableData = res.data.outmap.list
          this.total = res.data.outmap.total
        }
        this.loading = false;
      })
    },
    openImg(url) {
      window.open(url);
    },
    search() {
      this.getListEduGroup();
    },
    reset() {
      this.params.JTMC = '';
      this.params.timeRange = '';
      this.getListEduGroup();
    },
    addEduGroup(){
      this.form= {}
      this.fileList=[]
      this.type = 1
      this.title = '新增集团'
      this.dialogVisible = true;

    },
    update(row) {
      this.type = 2;
      this.title = '修改集团';
      let cs = {
        XLH: row.XLH,
      }
      getEduGroup(cs).then(res => {
        //console.log(res)
        this.form = res.data.outmap.data;
        this.dialogVisible = true;
      })
    },
    // 逻辑删除
    deleteLogical(row) {
      let cs = {
        XLH: row.XLH,
        SCZK: '1',
      }
      this.$confirm('是否删除该职教集团?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateEduGroup(cs).then(res => {
          if (res.data.outmap.status == "success") {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getListEduGroup();
          } else {
            this.$message({
              type: 'error',
              message: '删除失败，请联系管理员!'
            });
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 提交新增
    onSubmit() {
      //console.log(this.form);
      if(!this.form.JTMC){
        this.$message({
          type: 'error',
          message: '职教联盟名称不可为空'
        });
        return 0
      }
      this.$confirm('是否新增职教集团?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        addEduGroup(this.form).then(res => {
          if (res.data.outmap.status == "success") {
            this.$message({
              type: 'success',
              message: '新增成功!'
            });
            this.dialogVisible = false;
            this.getListEduGroup();
          } else {
            this.$message({
              type: 'error',
              message: '新增失败，请联系管理员!'
            });
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消新增'
        });
      });

    },
    onUpdate() {
      if(!this.form.JTMC){
        this.$message({
          type: 'error',
          message: '职教联盟名称不可为空'
        });
        return 0
      }
      this.$confirm('是否修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateEduGroup(this.form).then(res => {
          if (res.data.outmap.status == "success") {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
            this.dialogVisible = false;
            this.getListEduGroup();
          } else {
            this.$message({
              type: 'error',
              message: '修改失败，请联系管理员!'
            });
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消修改'
        });
      });
    },
    deleteLbt(row) {
      console.log(row)
    },
//关闭新增框
    closeWindow() {
      this.dialogVisible = false;
    },

    handleSizeChange(val) {

      this.params.pagesize = val;
      this.getListEduGroup();

    },
    // 跳页
    handleCurrentChange(val) {
      this.params.curpage = val;
      this.getListEduGroup();
    },
    //以下2个为富文本框方法
    afterChange() {
    },
    onContentChange(val) {
      console.log(val)
      this.$forceUpdate
      // window.console.log(this.form.TZNR)

    },
  },
  created() {
    getListEduGroup().then(res => {
      this.tableData = res.data.outmap.list
      this.total = res.data.outmap.total
      console.log(res)
    })
  },
  components: {
    editor
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/eduGroup/EduGroupMgt.vue